export var QUICK_DEPOSIT = 'QUICK_DEPOSIT';
export var DEPOSIT = 'DEPOSIT';
export var NONE = '';
//# sourceMappingURL=constants.js.map